import script from "./MemberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberDialog.vue?vue&type=script&setup=true&lang=js"

import "./MemberDialog.vue?vue&type=style&index=0&id=96bc0480&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96bc0480"]])

export default __exports__